import { useGetQuery } from "../hooks";
import Loading from "./Loading";
import { DataContext } from "../contexts";

export default function DataLoader({ children }) {
  const { data: memberUsers, isLoading: memberUsersLoading } =
    useGetQuery("users/members");

  const { data: adminUsers, isLoading: adminUsersLoading } =
    useGetQuery("users/admins");

  const { data: jobs, isLoading: jobsLoading } = useGetQuery("jobs");
  const { data: responsibilities, isLoading: responsibilitiesLoading } =
    useGetQuery("responsibilities");

  if (
    memberUsersLoading ||
    adminUsersLoading ||
    jobsLoading ||
    responsibilitiesLoading
  ) {
    return <Loading />;
  }

  function getMemberUserById(id) {
    return memberUsers.find((user) => user.id === id);
  }

  function getAdminUserById(id) {
    return adminUsers.find((user) => user.id === id);
  }

  function getJobById(id) {
    return jobs.find((job) => job.id === id);
  }

  function getResponsibilityById(id) {
    return responsibilities.find((responsibility) => responsibility.id === id);
  }

  return (
    <DataContext.Provider
      value={{
        memberUsers,
        adminUsers,
        jobs,
        responsibilities,
        getMemberUserById,
        getAdminUserById,
        getJobById,
        getResponsibilityById,
      }}
    >
      {children}
    </DataContext.Provider>
  );
}
